import React, { useEffect, useState } from 'react'
import { end_points } from '../../api/url/api_url'
import { useParams } from 'react-router-dom'
import { axiosInstance } from '../../api/axiosInstance/axiosInstance'
export let cnt=0;
const Cart = () => {
    let{uid}=useParams()

    let api=end_points.cart

    let[data,setData]=useState()
   
    const fetchdata=()=>{
        axiosInstance.get(api)
        .then(res=>{
            console.log("res",res.data);
            setData(res.data.filter((x) => x.user_id===uid))
        })
        .catch(err=>console.log("axios error",err))
    }
    useEffect(()=>{    
        fetchdata()
    },[api,setData])

    let removeItem=(id)=>{
        // console.log("remove",id);
        axiosInstance.delete(`${api}/${id}`).then((res)=>{
          console.log("success delete",res);
          fetchdata()
        }).catch((err)=>{
          console.log("error delete",err); 
        })
        }
        let total=[];
        let allTotal=0;
        let gst=0;
        let finalAmt=0;
  return (
    <div className="my-28 flex justify-center">
      <section>
        <div className="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
          <div className="mx-auto max-w-3xl">
            <header className="text-center">
              <h1 className="divider md:text-3xl py-4 hover:text-transparent bg-clip-text bg-gradient-to-r from-[#19c5ff] via-[#13ff13] to-[#ffff48] font-bold  text-[#ff4444] sm:text-3xl">
                Your Cart  
              </h1>
            </header>

            <div className="mt-8">
              <ul className="space-y-6">
                {data?.map((x,i) => (
                  
                  cnt=i+1,

                  total.push(Math.floor(x?.prod_price)),
                  allTotal=total.reduce((initial,current)=>initial+current),
                  // console.log(allTotal),
                  gst=Math.round(allTotal*.18),
                  finalAmt=allTotal+gst, 

                   <li className="flex items-center gap-4">
                    <img
                      src={x?.prod_img}
                      alt=""
                      className="size-16 rounded object-cover"
                    />

                    <div>
                      <h3 className="text-md font-medium text-gray-900 text-start">
                      {x?.prod_name}
                      </h3>
                      

                      <dl className="mt-0.5 space-y-px text-[10px] text-gray-600">
                        <div>
                          <dt className="inline text-xs font-medium">Price: </dt>
                          <dd className="inline text-xs font-semibold">{x?.prod_price}</dd>
                        </div>

                        <div className='text-start font-bold'>
                          <dt className="inline">Color: </dt>
                          <dd className="inline"> {x?.prod_col}</dd>
                        </div>
                      </dl>
                    </div>

                    <div className="flex flex-1 items-center justify-end gap-2">
                      <form>
                        <label htmlFor="Line1Qty" className="sr-only">
                          {" "}
                          Quantity{" "}
                        </label>

                        <input
                          type="number"
                          min="1"
                          value="1"
                          id="Line1Qty"
                          className="h-8 w-12 rounded border-gray-200 bg-gray-50 p-0 text-center text-xs text-gray-600 [-moz-appearance:_textfield] focus:outline-none [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none"
                        />
                      </form>

                      <button className="text-gray-600 transition hover:text-red-600" onClick={()=>{removeItem(x.id)}}>
                        <span className="sr-only">Remove item</span>

                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="size-4"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                          />
                        </svg>
                      </button>
                    </div>
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex justify-end border-t border-gray-100 pt-8">
                <div className="w-screen max-w-lg space-y-4">
                  <dl className="space-y-0.5 text-sm text-gray-700">
                    <div className="flex justify-between">
                      <dt>Subtotal</dt>
                      <dd>{allTotal}</dd>
                    </div>

                    <div className="flex justify-between">
                <dt>GST (18%)</dt>
                
                <dd>{gst}</dd>
              </div>
<hr/>
                    <div className="flex justify-between !text-base font-medium">
                      <dt>Total</dt>
                      {}
                      <dd>₹{finalAmt}</dd>
                    </div>
                  </dl>

                  {/* <div className="flex justify-end">
              <span
                className="inline-flex items-center justify-center rounded-full bg-indigo-100 px-2.5 py-0.5 text-indigo-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="-ms-1 me-1.5 size-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
                  />
                </svg>

                <p className="whitespace-nowrap text-xs">2 Discounts Applied</p>
              </span>
            </div> */}

                  <div className="flex justify-end">
                    <button
                      
                      className="block rounded bg-gray-700 hover:bg-gradient-to-r from-[#5fd7ff] via-[#6bff6b] to-[#ffff69] hover:text-black hover:shadow-lg hover:uppercase font-semibold  px-5 py-3 text-sm text-gray-100 transition hover:bg-gray-600"
                    >
                      Checkout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Cart